
export class BatchWrapper {
bu: string;
criteriaKey: string;
domain: string;
errorCode: string;
fileName: string;
format: string;
locale: string;
login: string;
method: string;
requiredClass: string;
status: string;
url: string;
uuid: string;
}

